<template>
	<div class="wib-features">
		<section
			v-for="feature in bldFeaturesData"
			:key="feature.id"
			:class="{ 'wib-feature--reverse': Boolean(+feature.reverse_order_desktop) }"
			class="wib-feature"
		>
			<div class="container">
				<div class="row">
					<div class="col-md-6">
						<div class="wib-feature__image">
							<img :src="feature.logo_url" :alt="feature.title">
						</div>
					</div>
					<div class="col-md-6">
						<div class="wib-feature__content">
							<div class="wib-feature__content__icon">
								<img :src="feature.mini_logo_url" alt="Icon">
							</div>
							<h3 class="wib-feature__content__heading">
								{{ feature.title | stripTags }}
							</h3>
							<div class="wib-feature__content__text" v-html="feature.body" />
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>

export default {
	name: "BldFeatures",
	props: {
		bldFeaturesData: {
			type: Array,
			required: true
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@s/_asset-mixers.scss';

.wib-features {

    .wib-feature {
        background-color: #F4F4F4;
        padding: 100px 0;

        @media (min-width: 580px) and (max-width: 991px) {
            padding: 85px 0;
        }

        @media (max-width: 580px) {
            padding: 35px 0;
        }

        .row {
            align-items: center;
            display: flex;

            @media (max-width: 991px) {
                flex-direction: column-reverse;
            }

        }

        &__content {
            max-width: 450px;
            margin: 0 auto;

            &__heading {
                color: #444259;
                font-size: 36px;
                line-height: 43px;
                text-transform: uppercase;
            }

            &__text {
                color: #5F707F;
                font-size: 16px;
                line-height: 21px;

                @media (min-width: 580px) and (max-width: 991px) {
                    margin-bottom: 60px;
                }

                @media (max-width: 580px) {
                    margin-bottom: 30px;
                }
            }
        }

        &__image {
            max-width: 450px;
            margin: 0 auto;

            img {
                width: 100%;
            }
        }
    }

    .wib-feature--reverse {
        text-align: left;
        background-color: $white;

        .row {
            flex-direction: row-reverse;

            @media (max-width: 991px) {
                flex-direction: column-reverse;
            }
        }
    }

}
</style>

<style lang="scss">
.wib-feature {
    &__content__text {
        color: #5F707F;
        font-size: 16px;
        line-height: 21px;

        p {
            margin: 0;
        }
    }
}
</style>